import { TUser } from "../../../../common/types/user";
import DashboardWidget from "../../../../components/Common/dashboard-widget";

interface Props {
    totalCount?: number;
    recentUsers?: TUser[];
    isLoading: boolean;
}

const UsersWidget = ({ totalCount = 0, recentUsers = [], isLoading = false }: Props) => (
    <DashboardWidget
        title="Users"
        totalCountDescr="Total Users"
        recentCountDescr="New Users in the last 30 Days"
        buttonName="Users List"
        buttonLink="/users"
        totalCount={totalCount}
        recentCount={recentUsers?.length}
        isLoading={isLoading}
    />
);

export default UsersWidget;
